import React from 'react'
import { createRoot } from 'react-dom/client'
import 'navigator.sendbeacon'
import { Row, Col } from 'react-bootstrap'

import { Tracking, TrackingProvider } from '../utils'
import packageJson from '../../package.json'
import OrganisationComponent from './OrganisationComponent'
import { default as CatalogOrderComponent } from '../CatalogOrder'

const { version: APP_VERSION } = packageJson

const OrganisationsApp = ({
  gaId,
  gaDebug,
  mtId,
  mtUrl,
  ...props
}) => {
  const tracker = new Tracking({
    enabled: !!(mtId || gaId),
    gaId,
    mtId,
    mtUrl,
    debug: false
  })

  navigator.sendBeacon(
    'https://api.apps.austauschkompass.de/organisations_component/track',
    JSON.stringify({ version: APP_VERSION, url: document.location.href })
  )

  return (
    <TrackingProvider tracker={tracker}>
      <OrganisationComponent {...props}>
        {({ selectedOrganisation, countryCode, onFinish }) => (
          <Row>
            <Col lg={{ span: 10, offset: 1 }} xxl={{ span: 8, offset: 2 }}>
              <CatalogOrderComponent
                orderApiUrl={props.orderApiUrl}
                orderApiToken={props.orderApiToken}
                crmApiUrl={props.crmApiUrl}
                crmApiToken={props.crmApiToken}
                businessArea={props.businessArea}
                upsell={props.upsell}
                upsellPrechecked={props.upsellPrechecked}
                organisationId={selectedOrganisation.slug}
                interestInSchoolPrograms={props.businessArea === 'schueleraustausch'
                  ? selectedOrganisation
                    .additional_config
                    .school_programs_upsell_only
                  : false}
                exchangeCountryCode={countryCode}
                onFinish={onFinish}
              />
            </Col>
          </Row>
        )}
      </OrganisationComponent>
    </TrackingProvider>
  )
}

const DEFAULT_SCHUELERAUSTAUSCH_CONFIG = {
  upsell: true,
  upsellPrechecked: false,
  userFilter: false,
  orderApiUrl: 'https://api.orders.austauschkompass.de',
  crmApiUrl: 'https://api.crm.austauschkompass.de',
  ratingApiUrl: 'https://www.schueleraustausch.de',
  filter_catalogEnabledOnly: true,
}

const DEFAULT_SPRACHREISEN_CONFIG = {
  upsell: true,
  upsellPrechecked: false,
  userFilter: true,
  orderApiUrl: 'https://api.orders.austauschkompass.de',
  crmApiUrl: 'https://api.crm.austauschkompass.de',
  ratingApiUrl: 'https://ratings.austauschkompass.de',
  filter_catalogEnabledOnly: true,
  //filter_targetGroup: 'seniors',
  //filter_countryCode: 'MT',
}

const FILTER_KEY_REGEX = /^filter_/

const htmlEnvToProps = ({ el /* , queryArgs */ }) => {
  let akConfig = JSON.parse(el.dataset.akConfig)

  const DEFAULT_CONFIG = akConfig.businessArea === 'schueleraustausch'
    ? DEFAULT_SCHUELERAUSTAUSCH_CONFIG
    : DEFAULT_SPRACHREISEN_CONFIG
  let filterConfig = {}

  Object.keys(DEFAULT_CONFIG).forEach((key) => {
    /* NOTE: We treat `""` (empty string), `null` and `undefined` in
    `akConfig` the same and override it with the defaults in
    DEFAULT_CONFIG. Using `Object.assign({}, DEFAULT_CONFIG,
    akConfig)` instead would not!
     */
    if (!(key in akConfig)) {
      akConfig[key] = DEFAULT_CONFIG[key]
    }
  })

  Object.keys(akConfig).forEach((key) => {
    if (key.match(FILTER_KEY_REGEX)) {
      const nestedKeyName = key.replace(FILTER_KEY_REGEX, '')
      filterConfig[nestedKeyName] = akConfig[key]
      delete akConfig[key]
    }
  })

  const mtUrl = 'https://stats.schueleraustausch.net'

  // Use global tracking ids by default
  const mtId = window.AK_TRACKING_MT_ID
  const gaId = window.AK_TRACKING_GA_ID

  // but allow explicitly set ones to override them
  const props = Object.assign({ mtId, gaId, mtUrl }, akConfig, {
    referrer: document.location.href,
    filter: filterConfig
  })

  return props
}

export {
  OrganisationComponent as default,
  OrganisationsApp,
  htmlEnvToProps,
}
